import React from 'react';
import { type FallbackProps } from 'react-error-boundary';

import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';
import GeneralErrorBoundaryUI from 'components/errorBoundary/GeneralErrorBoundaryUI';

/**
 * withErrorBoundary는 컴포넌트를 에러바운더리로 감싸주는 HOC
 */
function withErrorBoundary<T extends Record<string, unknown>>(
  WrappedComponent: React.ComponentType<T>,
  fallbackComponent: React.ComponentType<FallbackProps> = GeneralErrorBoundaryUI
) {
  const ComponentWithErrorBoundary = (props: T) => (
    <ErrorBoundary fallbackComponent={fallbackComponent}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <WrappedComponent {...(props as any)} />
    </ErrorBoundary>
  );

  ComponentWithErrorBoundary.displayName = `withErrorBoundary(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return ComponentWithErrorBoundary;
}

export default withErrorBoundary;
